<template>
  <div class="single-kpi-counter-box">
    <div>{{ counterName }}</div>
    <div>{{ counterTarget }}</div>
    <v-divider />
    <div>{{ value }}</div>
    <div v-if="dimensionId">dimensionId: {{ dimensionId }}</div>
    <v-btn icon small color="primary" class="delete-btn" @click="remove">
      <v-icon small>mdi-close</v-icon>
    </v-btn>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { DIMENSIONS } from '@/constants/statistics/constants';

export default {
  name: 'SingleKPICounterBox',

  props: {
    counterTypeId: {
      type: String,
      required: true
    },
    handlerId: {
      type: String,
      required: true
    },
    dimensionId: {
      type: String,
      default: null
    }
  },

  data() {
    return {};
  },

  computed: {
    ...mapGetters('AGENT', ['loggedInAgent']),

    ...mapGetters('STATS', ['getSubscribedCounter']),

    ...mapGetters('BUSINESS_PROCESSES', ['availableBusinessProcesses']),

    kpiRepresentation() {
      return {
        counterTypeId: this.counterTypeId,
        handlerId: this.handlerId,
        dimensionId: this.dimensionId || undefined
      };
    },

    counter() {
      return (this.loggedInAgent.organizationData.counters || []).find(
        ({ counterTypeId }) => counterTypeId === this.counterTypeId
      );
    },

    counterName() {
      return this.counter.counterTypeName.replace(this.counterHandler, '');
    },

    counterHandler() {
      return DIMENSIONS.counterTypeHandler[parseInt(this.counter.counterTypeHandler)];
    },

    counterTarget() {
      const type = this.counterHandler;

      switch (type) {
        case 'Business Process':
          return this.getBusinessProcessName(this.handlerId);
        case 'Agent':
          return this.loggedInAgent.name;
        default:
          return 'Unknown';
      }
    },

    value() {
      return this.getSubscribedCounter(this.kpiRepresentation) || 'N/A';
    }
  },

  methods: {
    ...mapActions('STATS', ['removeKpiSubscription']),

    remove() {
      this.removeKpiSubscription(this.kpiRepresentation);
    },

    getBusinessProcessName(businessProcessId) {
      const bp = this.availableBusinessProcesses.find(({ id }) => id === businessProcessId);
      return bp && bp.name;
    }
  }
};
</script>

<style scoped>
.single-kpi-counter-box {
  background-color: var(--v-surface-lighten1);
  border-radius: 8px;
  margin: 16px 0 0 16px;
  display: inline-block;
  padding: 8px 40px 8px 8px;
  position: relative;
}
.delete-btn {
  position: absolute;
  top: 4px;
  right: 4px;
}
</style>
